import {createSvgIcon} from '../create-svg-icon';

export const DensitySmallIcon = createSvgIcon(
  <path d="M3 2h18v2H3zm0 18h18v2H3zm0-6h18v2H3zm0-6h18v2H3z" />
, 'DensitySmallOutlined');
